import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'wonderbly-components/lib/Icon';
import CountryOption from './CountryOption';

const Options = props => (
  <div
    className={cx('country-options', {
      'country-options-open': props.open,
      [`country-options-${props.for}`]: props.for,
    })}>
    <div className="country-options-bg" onClick={props.onClose} />
    <div className="country-options-inner">
      <button
        type="button"
        className="country-option-close"
        onClick={props.onClose}>
        <Icon icon="delete" />
      </button>
      <h3>{props.title}</h3>
      <div className="country-options-wrap">
        {props.options
          ? [
            props.options.map(option => (
              <CountryOption
                key={`${option.iso}-${option.locale}`}
                value={option}
                isActive={
                  `${option.iso}-${option.locale}` ===
                  `${props.currentValue.iso}-${props.currentValue.locale}`
                }
              />
            )),
            props.changeCountry.name && (
              <CountryOption
                key="change-country"
                value={props.changeCountry}
              />
            ),
          ]
          : 'No options!'}
      </div>
    </div>
  </div>
);

Options.propTypes = {
  changeCountry: PropTypes.object.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentValue: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  for: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func,
};

export default Options;
